var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-update',{attrs:{"model":_vm.model},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var error = ref.error;
var fetch = ref.fetch;
var item = ref.item;
var loading = ref.loading;
var submit = ref.submit;
return [_c('show-person-options-form',{attrs:{"with-data":item,"error":error,"loading":loading},on:{"submit":submit,"reset":fetch}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }